var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hiq-important-message-banner"},_vm._l((this.messages),function(msg,i){return _c('Message',{key:i,attrs:{"message":msg}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }